import { useTheme } from '@emotion/react'
import { Close } from '@mui/icons-material'
import { Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from '@mui/material'
import React from 'react'

const CustomPopup = ({ children, sx = {}, open, handleClose, title = "", titleSx = {}, subTitle, DialogContentSx={} }) => {
    const theme = useTheme()
    return (
        <Dialog
            sx={(theme) => ({
                "& .MuiPaper-root": {
                    backgroundColor: theme.palette.customColors.yellow_bg,
                },
                "& > .MuiDialog-container > .MuiPaper-root": {
                    // borderRadius: "8px"
                }
            })}
            open={open} onClose={handleClose} maxWidth="sm" fullScreen>
            <DialogTitle sx={{ borderBottom: `0px solid ${theme.palette.customColors.gray300}`, paddingBlock: { xs: "1.5rem", md: "4rem 0rem" } }}>
                {/* <Typography variant='h1' fontWeight={700} fontSize={"1.3rem"} textAlign={'center'}>Profile Completion</Typography> */}
                <Grid style={{ flex: 1 }}>
                    <Typography fontWeight={700} fontSize={{ xs: "1.6rem", sm: "2rem", md: "2.5rem", lg: "2.5rem" }} textAlign={'center'} sx={{ ...titleSx }}>{title}</Typography>
                    {subTitle && <Typography variant="body1" marginTop={3} textAlign={'center'} marginBottom={{ xs: "0rem", md: "1rem" }}>
                        {subTitle}
                    </Typography>}
                </Grid>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{ position: "absolute", right: 8, top: 8 }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{
                width: 'calc(100% - 3rem)',
                maxWidth: '900px',
                marginInline: 'auto',
                overflowY: 'hidden',
                ...DialogContentSx
                // marginTop: "-1rem"
                // marginTop: "1.5rem"
            }}>
                <Grid sx={{
                    display: 'grid',
                    gap: '0.5rem',
                    padding: "1rem",
                    // bgcolor: "#fff",
                    borderRadius: "10px",
                    // border: "1px solid rgb(235 232 251)",
                    // placeContent: { xs: "start", md: 'start' },
                    // alig
                    justifyContent: 'center',
                    maxHeight: { xs: 'calc(100dvh - 10.5rem)', md: 'calc(100dvh - 9.5rem)' },
                    overflowY: { xs: "auto", md: 'auto' },

                    "&::-webkit-scrollbar": {
                        display: "none",
                    },
                    "-ms-overflow-style": "none", // Hide scrollbar in IE and Edge
                    "scrollbar-width": "none", // Hide scrollbar in Firefox
                    ...sx
                }}>
                    {children}
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

export default CustomPopup